import { useSelector } from 'react-redux';
import { TextShow } from 'Utils/Helpers/TextShow';
import PatientShow from 'Screens/Home/SystemPatient/components/PatientShow';
import GetAppointmentType from 'Utils/Helpers/AppointmentType';
import GetAppointmentStatus from 'Utils/Helpers/AppointmentStatus';
import AppointmentStatusEdit from '../manager/StatusEdit';
import GetAppointmentTime from 'Utils/Helpers/AppointmentTime';
import AppointmentTypeEdit from '../manager/EditAppointmentType';
import AppointmentDelete from '../manager/DeleteAppointment';
import AppointmentNewPayment from '../manager/NewPayment';
import AppointmentHistory from '../history';
import * as icons from 'react-bootstrap-icons';
import { enqueueSnackbar } from 'notistack';
import { HandleVibrate } from 'Utils/Helpers/HandleApiData';

export default function OneAppointmets({ data, noName, patient, className}) {
    const { current } = useSelector((state) => ({
        current: state.staff.current,
    }));
    const onChangeOpenStatus = () => {
        enqueueSnackbar(<span>{"برای مشاهده وضعیت‌ها دکمه "}{<icons.ClockHistory size={16} className='mx-2'/>}{" را کلیک نمایید"}</span>, {variant: 'info'});
        // dispatch(setOpenStatusHistory({ open: true, tab: '1', data: JSON.stringify(data) }));
    }
    const onChangeOpenPayment = () => {
        enqueueSnackbar(<span>{"برای مشاهده پرداخت‌ها دکمه "}{<icons.ClockHistory size={16} className='mx-2'/>}{" را کلیک نمایید"}</span>, {variant: 'info'});
        // dispatch(setOpenStatusHistory({ open: true, tab: '2', data: JSON.stringify(data) }));
    }
    const onMouseUp = (e) => {
        HandleVibrate();
    }
    return (
        <div className='each-appointment with-shadow'>
            <div className='each-appointment-extra'>
                <div className={`each-appointment-actions ${patient ? 'item3' : 'item4'}`}>
                    {
                        data.lastStatus !== 5 ? 
                        <>
                            <>
                                {
                                    !patient && (
                                        data.lastStatus !== 4
                                        ? <AppointmentStatusEdit key={`app_sted_${data.id}`} id={data.id}/>
                                        : <AppointmentNewPayment key={`app_pay_${data.id}`} id={data.id} />
                                    )
                                }
                            </>
                            <AppointmentHistory key={`app_his_${data.id}`} data={data} patient={patient}/>
                            <AppointmentTypeEdit key={`app_typ_${data.id}`} data={data} patient={patient}/>
                            <AppointmentDelete key={`app_del_${data.id}`} data={data} patient={patient}/>
                        </> : <AppointmentHistory key={`app_his_alt_${data.id}`} data={data} patient={patient}/>
                    }
                </div>
                {
                    current[1][2] &&
                    <>
                        <div className='each-appointment-data status' onClick={onChangeOpenStatus} onMouseUp={onMouseUp}>
                            <icons.ArrowLeftRight />
                            {data.statusList.length}
                        </div>
                        <div className='each-appointment-data payment' onClick={onChangeOpenPayment} onMouseUp={onMouseUp}>
                            <icons.CurrencyDollar />
                            {data.paymentList.length}
                        </div>
                    </>
                }
            </div>
            <div className={`each-appointment-info status-${data.lastStatus}`}>
                <div className='infos'>
                    {
                        !noName &&
                        <PatientShow
                            name={data.name}
                            nCode={data.nCode}
                            mobile={data.mobile}
                            uniCode={data.uniCode}
                        />
                    }
                    <TextShow
                        title={"تاریخ نوبت :"}
                        data={<GetAppointmentTime id={data.time} date={data.date} status={data.lastStatus} AppointmentPage inDate/>}
                    />
                </div>
                <div className='infos'>
                    <TextShow
                        title={"وضعیت :"}
                        data={<GetAppointmentStatus id={data.lastStatus}/>}
                    />
                    <TextShow
                        title={'نوع :'}
                        data={<GetAppointmentType id={data.type} />}
                    />
                </div>
            </div>
        </div>
    );
}